import React, { useEffect, useState } from 'react';
import { Box, Typography, IconButton, useMediaQuery } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTheme } from '@mui/material/styles';

const Countdown = () => {
  const targetDate = new Date('2026-06-11T18:00:00-06:00').getTime();
  const [timeLeft, setTimeLeft] = useState(getTimeRemaining());
  const [visible, setVisible] = useState(true);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  function getTimeRemaining() {
    const now = new Date().getTime();
    const difference = targetDate - now;

    if (difference <= 0) {
      return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    }

    return {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / (1000 * 60)) % 60),
      seconds: Math.floor((difference / 1000) % 60),
    };
  }

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(getTimeRemaining());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  if (!visible) return null;

  const handleRedirect = () => {
    window.location = 'mundial-mexico';
  };

  return (
    <Box
      sx={{
        position: 'fixed',
        top: isMobile ? '65px' : '90px',
        left: isMobile ? '5px' : '7px',
        backgroundColor: 'rgba(181, 236, 3, 0.85)',
        color: '#2D1E5A',
        px: isMobile ? 1 : 2,
        py: isMobile ? 1 : 2,
        borderRadius: '15px',
        zIndex: 9999,
        boxShadow: 3,
        width: isMobile ? '50%' : 'auto',
        fontFamily: 'MuseoModerno',
        minWidth: 'fit-content',
        cursor: 'pointer',
        textAlign: 'center'
      }}
      onClick={handleRedirect}
    >
      {/* Botón de cerrar */}
      <IconButton
        size="small"
        onClick={(e) => {
          e.stopPropagation();
          setVisible(false);
        }}
        sx={{ position: 'absolute', top: 0, right: 0, color: '#2D1E5A' }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>

      {/* Título centrado */}
      <Box sx={{ textAlign: 'center' }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 'bold', fontFamily: 'MuseoModerno', color: 'rgb(45, 30, 90)', fontSize: isMobile ? '14px' : '1.3 rem'  }}>
          Mundial México 2026
        </Typography>
      </Box>

      {/* Countdown horizontal */}
      <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
        {['Días', 'Hrs', 'Min', 'Seg'].map((label, index) => {
          const value = [timeLeft.days, timeLeft.hours, timeLeft.minutes, timeLeft.seconds][index];
          return (
            <Box key={label} sx={{ textAlign: 'center' }}>
              <Typography variant="caption" sx={{fontFamily: 'MuseoModerno', color: 'rgb(45, 30, 90)', fontSize: isMobile ? '10px' : '0.75rem'}}>{label}</Typography>
              <Typography sx={{ fontWeight: 'bold', fontSize: isMobile ? '12px' : '1rem', fontFamily: 'MuseoModerno', color: 'rgb(45, 30, 90)' }}>{value}</Typography>
            </Box>
          );
        })}
      </Box>
      <Typography variant='p' textAlign='center' sx={{fontSize: isMobile ? '10px' : '14px'}}>Más Información <i class="bi bi-hand-index-thumb"></i></Typography>
    </Box>
  );
};

export default Countdown;
